<template>
  <div
    class="container mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-18 mb-12 px-4"
  >
    <div>
      <h1
        class="text-center mx-auto max-w-6xl text-3xl lg:text-5xl mb-10"
        v-html="trans.title"
      ></h1>
      <p class="text-lg md:text-xl text-center">
        {{ trans.description }}
      </p>
    </div>
    <div class="mt-12 sm:mt-24">
      <div class="rich-text-content" v-html="trans.content"></div>
    </div>
  </div>
</template>

<script lang="ts">
import moment from "moment";

const trans = {
  en: {
    title: "Data Processing Agreement",
    content:
      " Complying with the European Union's General Data Protection Regulation (GDPR) is a top priority at QRDove. We're sure you have more than one question on this, and we're here to help you navigate your GDPR journey.",
    pls: "Please get in touch with us for more details.",
  },
  de: {
    title: "Datenverarbeitungsvereinbarung",
    content:
      " Die Einhaltung der Datenschutz-Grundverordnung (DSGVO) der Europäischen Union hat bei QRDove höchste Priorität. Wir sind sicher, dass Sie mehr als eine Frage dazu haben, und wir sind hier, um Ihnen bei Ihrem Weg zur DSGVO zu helfen.",
    pls: "Bitte kontaktieren Sie uns für weitere Details.",
  },
  es: {
    title: "Acuerdo de procesamiento de datos",
    content:
      " Cumplir con el Reglamento General de Protección de Datos (GDPR) de la Unión Europea es una prioridad máxima en QRDove. Estamos seguros de que tiene más de una pregunta sobre esto, y estamos aquí para ayudarlo a navegar su viaje GDPR.",
    pls: "Por favor, póngase en contacto con nosotros para más detalles.",
  },
  fr: {
    title: "Accord de traitement des données",
    content:
      " Le respect du règlement général sur la protection des données (RGPD) de l'Union européenne est une priorité absolue chez QRDove. Nous sommes sûrs que vous avez plus d'une question à ce sujet, et nous sommes là pour vous aider à naviguer dans votre parcours RGPD.",
    pls: "Veuillez s'il vous plaît nous contacter pour plus de details.",
  },
  it: {
    title: "Accordo sul trattamento dei dati",
    content:
      " Il rispetto del Regolamento generale sulla protezione dei dati (GDPR) dell'Unione Europea è una priorità assoluta per QRDove. Siamo sicuri che tu abbia più di una domanda al riguardo e siamo qui per aiutarti a navigare nel tuo percorso GDPR.",
    pls: "Si prega di mettersi in contatto con noi per maggiori dettagli.",
  },
  ja: {
    title: "データ処理契約",
    content:
      " QRDoveでは、欧州連合の一般データ保護規則（GDPR）に準拠することが最優先事項です。これについて複数の質問があると確信しています。GDPRの旅をナビゲートするお手伝いをします。",
    pls: "詳しくはお問い合わせください。",
  },
  nl: {
    title: "Gegevensverwerkingsovereenkomst",
    content:
      " Het naleven van de Algemene Verordening Gegevensbescherming (AVG) van de Europese Unie is een topprioriteit bij QRDove. We zijn er zeker van dat u hier meer dan één vraag over heeft, en we zijn hier om u te helpen bij uw AVG-reis.",
    pls: "Neem contact met ons op voor meer informatie.",
  },
  pt: {
    title: "Contrato de Processamento de Dados",
    content:
      " O cumprimento do Regulamento Geral de Proteção de Dados da União Europeia (GDPR) é uma das principais prioridades do QRDove. Temos certeza de que você tem mais de uma pergunta sobre isso e estamos aqui para ajudá-lo a navegar em sua jornada de GDPR.",
    pls: "Por favor entre em contato conosco para mais detalhes.",
  },
  vi: {
    title: "Thỏa thuận xử lý dữ liệu",
    content:
      " Tuân thủ Quy định chung về bảo vệ dữ liệu của Liên minh Châu Âu (GDPR) là ưu tiên hàng đầu tại QRDove. Chúng tôi chắc chắn rằng bạn có nhiều hơn một câu hỏi về vấn đề này và chúng tôi ở đây để giúp bạn điều hướng hành trình GDPR của mình.",
    pls: "Hãy liên lạc với chúng tôi để biết thêm chi tiết.",
  },
  zh: {
    title: "数据处理协议",
    content:
      "QRDove 遵守欧盟的《通用数据保护条例》（GDPR）是我们的首要任务。我们相信您对此可能有更多的问题，我们愿意帮助您顺利完成GDPR之旅。",
    pls: "如需更多详情，请与我们联系。",
  },
  tr: {
    locale: "tr",
    title: "Veri İşleme Anlaşması",
    content:
      "Avrupa Birliği'nin Genel Veri Koruma Yönetmeliği'ne (GDPR) uymak QRDove'da en yüksek önceliğimizdir. Bu konuda birden fazla sorunuz olduğundan eminiz ve GDPR yolculuğunuzda size yardımcı olmak için buradayız.",
    pls: "Daha fazla bilgi için lütfen bizimle iletişime geçin.",
  },
  hi: {
    locale: "hi",
    title: "डेटा प्रोसेसिंग समझौता",
    content:
      "यूरोपीय संघ के सामान्य डेटा सुरक्षा विनियमन (जीडीपीआर) का पालन करना QRDove में एक सर्वोच्च प्राथमिकता है। हमें यकीन है कि आपके पास इस पर एक से अधिक प्रश्न हैं, और हम आपकी जीडीपीआर यात्रा में आपकी सहायता करने के लिए यहां हैं।",
    pls: "अधिक जानकारी के लिए कृपया हमसे संपर्क करें।",
  },
  id: {
    locale: "id",
    title: "Perjanjian Pemrosesan Data",
    content:
      "Mematuhi Peraturan Perlindungan Data Umum (GDPR) Uni Eropa adalah prioritas utama di QRDove. Kami yakin Anda memiliki lebih dari satu pertanyaan tentang ini, dan kami di sini untuk membantu Anda menavigasi perjalanan GDPR Anda.",
    pls: "Silakan hubungi kami untuk detail lebih lanjut.",
  },
  th: {
    locale: "th",
    title: "ข้อตกลงการประมวลผลข้อมูล",
    content:
      "การปฏิบัติตามข้อกำหนดว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลทั่วไป (GDPR) ของสหภาพยุโรปเป็นสิ่งสำคัญอันดับแรกที่ QRDove เรามั่นใจว่าคุณมีคำถามมากกว่าหนึ่งข้อเกี่ยวกับเรื่องนี้ และเราพร้อมช่วยเหลือคุณในการเดินทางของ GDPR",
    pls: "โปรดติดต่อเราเพื่อขอรายละเอียดเพิ่มเติม",
  },
};
export default {
  data() {
    const { locale } = useI18n();
    //@ts-ignore
    const transx = trans[locale.value] ? trans[locale.value] : trans["en"];
    const datajd = useDataJd();
    const meta = useMeta();

    const i18nHead = useLocaleHead({
      addSeoAttributes: {
        canonicalQueries: ["/"],
      },
    });
    const meta_tags = meta.metaTag({
      title: transx.title,
      description: transx.description,
      url: datajd.currentURL(),
      image: datajd.assets("/images/og/homepage.jpg"),
    });
    useHead({
      title: transx.title,
      meta: [
        { name: "description", content: transx.description },
        ...(i18nHead.value.meta || []),
        ...meta_tags,
      ],
      htmlAttrs: {
        lang: i18nHead.value.htmlAttrs!.lang,
      },
      link: [...(i18nHead.value.link || [])],
    });
    useSchemaOrg([
      defineWebPage({
        name: transx.title,
        datePublished: moment("2023-05-03").toISOString(),
        dateModified: moment().toISOString(),
        description: transx.description,
        inLanguage: datajd.inLanguages(true),
        url: datajd.currentURL(),
        image: datajd.assets("/images/og/homepage.jpg"),
      }),
      defineBreadcrumb({
        itemListElement: [
          {
            item: {
              "@id": datajd.currentHost(),
              name: "Home",
            },
          },
          {
            item: {
              name: useI18n().t("footer.data_process"),
              "@id": datajd.currentHost() + useRoute().fullPath,
            },
          },
        ],
      }),
    ]);
    return {
      trans: transx,
    };
  },
};
</script>
